import { useEffect, useState, useRef } from 'react';
import { getAuth, applyActionCode, checkActionCode } from 'firebase/auth';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyUserEmail } from '../../services/userService';
import ModalComponent from '../../components/modal/modal.component';
import { VERIFIED_MODAL_CONTENT } from '../../constants';

const VerifyPage = () => {
	const [status, setStatus] = useState<'verifying' | 'success' | 'error'>(
		'verifying',
	);

	const [searchParams] = useSearchParams();
	const hasRun = useRef(false);

	useEffect(() => {
		if (hasRun.current) return;
		hasRun.current = true;

		const auth = getAuth();
		const oobCode = searchParams.get('oobCode');

		if (!oobCode) {
			console.error('Missing oobCode');
			setStatus('error');
			return;
		}

		const verify = async () => {
			try {
				const info = await checkActionCode(auth, oobCode);

				const email = info?.data?.email;
				if (!email) {
					console.error('Email not found in action code data');
					setStatus('error');
					return;
				}

				await applyActionCode(auth, oobCode);
				await verifyUserEmail(email);
				setStatus('success');
			} catch (error) {
				console.error('Error applying action code:', error);
				setStatus('error');
			}
		};

		verify();
	}, [searchParams]);

	const navigate = useNavigate();

	const modalContent = {
		verifying: {
			title: 'Verificando el email...',
			description: '',
		},
		success: {
			...VERIFIED_MODAL_CONTENT,
		},
		error: {
			title: 'Hubo un problema verificando tu email ❌',
			description: '',
		},
	};

	const { title, description } = modalContent[status];

	const showCloseButton = status !== 'verifying';

	return (
		<ModalComponent
			open
			title={title}
			description={description}
			imageSrc="/cambiapp_logo.png"
			buttonText="Volver al inicio"
			onClose={() => navigate('/login')}
			onButtonClick={() => navigate('/login')}
			showCloseButton={showCloseButton}
		/>
	);
};

export default VerifyPage;
